var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndless(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732862971059,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 25112,
    width: 128,
    height: 128,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.17 133.378a32 32 0 0 1 32.64-1.705l0.443 0.237 234.575 128a32 32 0 0 1 16.669 27.622l0.003 0.468v429.886l181.25 108.792L907 717.885V539.789L748.162 433.856l-67.182 50.407c-13.995 10.5-33.794 7.8-44.48-5.97l-0.321-0.422c-10.5-13.995-7.801-33.794 5.97-44.48l0.421-0.32 85.3-64a32 32 0 0 1 36.57-1.283l0.39 0.256 191.925 128A32.013 32.013 0 0 1 971 522.174V736a32 32 0 0 1-15.12 27.186l-0.411 0.25-213.25 128a32 32 0 0 1-32.502 0.258l-0.436-0.257-213.25-128a32 32 0 0 1-15.527-26.956L480.5 736V306.993L279.582 197.358 118 305.122v200.422l158.837 105.933 67.183-50.407c13.995-10.5 33.794-7.8 44.48 5.971l0.321 0.42c10.5 13.996 7.801 33.795-5.97 44.481l-0.421 0.321-85.3 64a32 32 0 0 1-36.57 1.283l-0.39-0.257-191.925-128A32.013 32.013 0 0 1 54 523.16V288a32 32 0 0 1 13.837-26.346l0.408-0.276 191.925-128z",
    "p-id": 25113,
    fill: "#5f7fe9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndless);
export default __webpack_public_path__ + "static/media/endless.451657088d0f54f9daa8a8003b39e17b.svg";
export { ForwardRef as ReactComponent };